import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { CaseUploadService } from '../case-upload.service';
import { ClientContractPackageService } from '../client-contract-package.service';
import { ClientContractProfileService } from '../client-contract-profile.service';
import { ComponentService } from '../component.service';
import { PersonalDetailsDataService } from '../personal-details-data.service';
import { PersonalDetailsService } from '../personal-details.service';
import { SaveConfirmationComponent } from '../save-confirmation/save-confirmation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-candidate-personal-details',
  templateUrl: './candidate-personal-details.component.html',
  styleUrls: ['./candidate-personal-details.component.scss']
})
export class CandidatePersonalDetailsComponent implements OnInit {
  personalDetails: any
  caseId: any
  case_id: any
  profile: any
  package: any
  components: any[] = []
  alacart:any
  //  tempComponents:any[]=[]
  navItems: any[] = []
  personalDetailsDataEntryForm = new FormGroup({
    status: new FormControl('')
  })
  personalDetailsFields: any = []
  inputqcComments: string
  statusInDb: string
  constructor(
    private componentService: ComponentService,
    private personalDetailsDataService: PersonalDetailsDataService,
    private caseUploadService: CaseUploadService,
    private clientContractProfileService: ClientContractProfileService,
    private clientContractPackageService: ClientContractPackageService,
    private activatedRoute: ActivatedRoute,
    private personalDetailsService: PersonalDetailsService,
    private snackBar: MatSnackBar,
    private dialog:MatDialog
  ) { }

  ngOnInit(): void {
    // console.log("access",this.activatedRoute.snapshot.queryParamMap.get('access_token'))
    this.getComponentDetails()
    this.getPersonalDetails()
  }
  // getPersonalDetails() {
  //   this.personalDetailsService.findForCde(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
  //     response => {
  //       this.personalDetailsFields = response[0].personalDetailsFields;
  //       console.log("Personal Detail Fields: ", this.personalDetailsFields)

  //       const dateDefault = (date) => {
  //         let dateValue = new Date(date);
  //         let dd = dateValue.getDate();
  //         let mm = dateValue.getMonth() + 1;
  //         let yyyy = dateValue.getFullYear().toString();
  //         let stringdd = '';
  //         let stringmm = ''

  //         if (dd < 10) {
  //           stringdd = '0' + dd;
  //         } else {
  //           stringdd = dd.toString();
  //         }
  //         if (mm < 10) {
  //           stringmm = '0' + mm;
  //         } else {
  //           stringmm = mm.toString();
  //         }
  //         return yyyy + '-' + stringmm + '-' + stringdd
  //       }

  //       this.personalDetailsFields[3].value = dateDefault(this.personalDetailsFields[3].value)
  //       this.personalDetailsFields[7].value = dateDefault(this.personalDetailsFields[3].value)
  //       this.addFormControlsForPersonalDetails();
  //     },
  //     error => {
  //       this.showError("Error Configuring Personal Details");
  //     }
  //   )
  // }

  // Added By Navin On 15/2/23
  getPersonalDetails() {
    this.personalDetailsService.findForCde(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
      response => {
        this.personalDetailsFields = response[0].personalDetailsFields;
        // console.log("Personal Detail Fields: ", this.personalDetailsFields);
  
        const dateDefault = (date) => {
          if (date) {
            let dateValue = new Date(date);
            let dd = dateValue.getDate();
            let mm = dateValue.getMonth() + 1;
            let yyyy = dateValue.getFullYear().toString();
  
            
            let stringdd = dd < 10 ? '0' + dd : dd.toString();
            let stringmm = mm < 10 ? '0' + mm : mm.toString();
  
            return `${yyyy}-${stringmm}-${stringdd}`;
          } else {
            return ''; 
          }
        };
  
        this.personalDetailsFields[3].value = dateDefault(this.personalDetailsFields[3].value);
        this.personalDetailsFields[7].value = dateDefault(this.personalDetailsFields[7].value);
        this.addFormControlsForPersonalDetails();
      },
      error => {
        this.showError("Error Configuring Personal Details");
      }
    );
  }
  
  readPersonalDetails() {
    this.personalDetailsDataService.readForCde(this.case_id, this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
      response => {
        if (response) {
          //          console.log(response);
          this.personalDetails = response._id;
          this.personalDetailsFields.forEach(item => {
            if (item.type != 'DATE') {
              this.personalDetailsDataEntryForm.get(item.name).setValue(response[item.name]);
            } else {
              //              console.log('this is the date type ',response[item.name]);
              //              this.personalDetailsDataEntryform.get(item.name).setValue(this.datePipe.transform(response[item.name],'yyyy-MM-dd'));
              let dateValue = new Date(response[item.name]);
              let dd = dateValue.getDate();
              let mm = dateValue.getMonth() + 1;
              let yyyy = dateValue.getFullYear().toString();
              let stringdd = '';
              let stringmm = ''

              if (dd < 10) {
                stringdd = '0' + dd;
              } else {
                stringdd = dd.toString();
              }
              if (mm < 10) {
                stringmm = '0' + mm;
              } else {
                stringmm = mm.toString();
              }
              //              console.log('converted value is ',yyyy+mm+stringdd)
              this.personalDetailsDataEntryForm.get(item.name).setValue(yyyy + '-' + stringmm + '-' + stringdd);
            }
          })
          if (response.status == 'CDE-REJECTED') {
            this.inputqcComments = response.inputqcComments
            this.statusInDb = response.status
          }
          //          this.personalDetailsDataEntryForm.get('status').setValue(response.status);
          //          this.personalDetailsDataEntryForm.get('insufficiencyComments').setValue(response.infsufficiencyComments);
          //          console.log('input qc status is ',response.inputqcStatus);
          //          console.log('input qc comments are ',response.inputqcComments);
          //          this.personalDetailsInputqcStatus = response.status;
          //          this.personalDetailsInputqcComments =response.inputqcComments;
          //          console.log("personal details  inputqcstatus is ",this.personalDetailsInputqcStatus);
        }

      },
      error => {
        this.showError(error.error.message);
      }
    )
  }
  async getComponentDetails() {
    await this.getCaseDetails()
    if (this.profile != null) {
      this.components = <any[]>await this.getProfileDetails()
    } else if (this.package != null) {
      this.components = <any[]>await this.getPackageDetails()
    } else if (this.alacart != null) {
      this.components = <any[]>await this.getalacartDetails()
    }
    //    this.components = <any[]>await this.addDisplayNameToComponents()
    await this.setComponentMenuItems()

    this.navItems.push({ displayName: 'Authorization', route: `candidate/candidatecomponentdataentry`, access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), children: [] })

    this.readPersonalDetails()

  }
  /*  addDisplayNameToComponents(){
      let promise = new Promise((resolve,reject)=>{
        this.tempComponents.forEach(item=>{
          this.componentService.findAComponentForCde(item.component,this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
            response=>{
              let comp = ({
                componentName : item.componentName,
                displayName :response.displayName,
                component:item.component,
                maxChecks:item.maxChecks
              })
              this.components.push(comp)
            },
            error=>{
              this.showError("Error getting display Name")
            }
          )
        })
        console.log("Components before resoving is ",this.components)
        resolve(this.components)
      })
      return promise
    }  */
  getCaseDetails() {
    let promise = new Promise((resolve, reject) => {
      this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          // console.log("Got reponse from cde case details")
          this.caseId = response.caseId
          this.case_id = response._id
          this.profile = response.profile
          this.package = response.package
          this.alacart = response.componentsToCheck
          // console.log("alacart",this.package),
          // console.log("alacart",this.alacart)
          resolve(true)
        },
        error => {
          this.showError("Error reading Case Details")
          resolve(false)
        })
    })
    return promise
  }
  getProfileDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractProfileService.getClientContractProfileDetails(this.profile + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          // console.log("Profile details are ", response2)
          this.navItems.push({
            displayName: 'Personal Details',
            route: `candidate/candidatepersonaldetails`,
            access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
            children: []
          })
          this.components = response2.clientContractProfileComponents
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
              //              this.employmentComponent=true
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
              //              this.addressComponent=true
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
              //              this.educationComponent=true
            } else if (item.componentName == 'globaldatabase') {
              // this.globaldatabaseComponent = true
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
              //              this.identityComponent=true
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == "cvanalysis") {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            } else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            }else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            }else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            }else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            }else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            }else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            }else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            }else if(item.componentName == 'globalmediasearch'){
              item.displayName = 'Global Media Search'
            }else if(item.componentName == 'facisl3'){
              item.displayName = 'FACIS L3 Check'
            }
          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }
  getPackageDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractPackageService.getClientContractPackageDetails(this.package + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          // console.log("Profile details are ", response2)
          this.navItems.push({
            displayName: 'Personal Details',
            route: `candidate/candidatepersonaldetails`,
            access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
            children: []
          })
          this.components = response2.clientContractPackageComponents
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
              //              this.employmentComponent=true
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
              //              this.addressComponent=true
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
              //              this.educationComponent=true
            } else if (item.componentName == 'globaldatabase') {
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
              //              this.identityComponent=true
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == "cvanalysis") {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            } else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            }else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            }else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            }else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            }else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            }else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            }else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            }else if(item.componentName == 'globalmediasearch'){
              item.displayName = 'Global Media Search'
            }else if(item.componentName == 'facisl3'){
              item.displayName = 'FACIS L3 Check'
            }
          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }
      ///
      getalacartDetails() {
        let promise = new Promise((resolve, reject) => {
          this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
          // this.clientContractPackageService.getClientContractComponentsDetails(this.alacart + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
            response2 => {
              // console.log("Profile details are ", response2)
              this.navItems.push({
                displayName: 'Personal Details',
                route: 'candidate/candidatepersonaldetails',
                access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
                children: []
              })
              this.components = response2.componentsToCheck
              // console.log("components to check",response2)
              // console.log("components to check",this.components)
              this.components.forEach(item => {
                if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
                  item.displayName = 'Employment'
                } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
                  item.displayName = 'Address'
                } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
                  item.displayName = 'Education'
                } else if (item.componentName == 'globaldatabase') {
                  item.displayName = 'Global Database'
                } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
                  item.displayName = 'Reference'
                } else if (item.componentName == 'criminalrecord') {
                  item.displayName = 'Criminal Record'
                } else if (item.componentName == 'courtrecord') {
                  item.displayName = 'Court Record'
                } else if (item.componentName == 'identity') {
                  item.displayName = 'Identity'
                } else if (item.componentName == 'gapvfn') {
                  item.displayName = 'GAP'
                } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
                  item.displayName = 'Drug Test'
                } else if (item.componentName == 'cvanalysis') {
                  item.displayName = 'CV Analysis'
                } else if (item.componentName == 'creditcheck') {
                  item.displayName = 'Credit Check'
                }  else if (item.componentName == 'uan') {
                  item.displayName = 'UAN'
                }else if (item.componentName == 'twentysixas') {
                  item.displayName = 'Form 26 AS'
                }else if (item.componentName == 'credittrans') {
                  item.displayName = 'Credit Check - TransUnion'
                }else if (item.componentName == 'epfo') {
                  item.displayName = 'EPFO Check'
                }else if (item.componentName == 'crconline') {
                  item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
                }else if (item.componentName == 'ofac') {
                  item.displayName = 'OFAC Check'
                }else if (item.componentName == 'socialmedia') {
                  item.displayName = 'Social Media Search'
                }else if(item.componentName == 'globalmediasearch'){
                  item.displayName = 'Global Media Search'
                }else if(item.componentName == 'facisl3'){
                  item.displayName = 'FACIS L3 Check'
                }
    
              })
              resolve(this.components)
            },
            error2 => {
              this.showError("Error reading profile details")
              resolve(null)
            }
          )
        })
        return promise
      }
    
      ////
  // setComponentMenuItems() {
  //   let promise = new Promise((resolve, reject) => {
  //     this.components.forEach(item => {
  //       console.log("Item in component details ", item)
  //       let childItems = []
  //       if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {


  //         for (let i = 0; i < item.maxChecks; i++) {
  //           if (i == 0) {
  //             childItems.push({ displayName: "Current Employment", component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
  //             continue
  //           }
  //           childItems.push({ displayName: "Previous " + item.displayName + "-" + (i), component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
  //         }
  //       } else {
  //         for (let i = 0; i < item.maxChecks; i++) {
  //           childItems.push({ displayName: item.displayName + "-" + (i + 1), component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
  //         }
  //       }


  //       console.log("ChildItems: ", childItems)
  //       this.navItems.push({ displayName: item.displayName, children: childItems })
  //       resolve(true)
  //     })

  //   })
  //   return promise
  // }
  // setComponentMenuItems() {
  //   let promise = new Promise((resolve, reject) => {
  //     this.components.forEach(item => {
  //       console.log("Item in personal details ", item)
  //       let childItems = []
  //       if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {


  //         for (let i = 0; i < item.maxChecks; i++) {
  //           if (i == 0) {
  //             childItems.push({ displayName: "Current Employment" + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
  //             continue
  //           }
  //           childItems.push({ displayName: "Previous " + item.displayName + "-" + (i), route: `candidate/candidatecomponentdataentry`, component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
  //         }
  //       }
  //       else {
  //         for (let i = 0; i < item.maxChecks; i++) {
  //           childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
  //         }
  //       }
  //       this.navItems.push({ displayName: item.displayName, children: childItems })
  //       resolve(true)
  //     })
  //   })
  //   return promise
  // }
  setComponentMenuItems() {
    let promise = new Promise((resolve, reject) => {
      this.components.forEach(item => {
        // console.log("Item in component details ", item)
        let childItems = []
        if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {


          for (let i = 0; i < item.maxChecks; i++) {
            if (i == 0) {
              childItems.push({ displayName: "Current Employment" + "-" + (i) , component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
              continue
            }
            childItems.push({ displayName: "Previous " + item.displayName + "-" + (i), component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
          }
        } else {
          for (let i = 0; i < item.maxChecks; i++) {
            // childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
            // childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
            childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
          }
        }


        // console.log("ChildItems: ", childItems)
        this.navItems.push({ displayName: item.displayName, children: childItems, disable:true })
        resolve(true)
      })

    })
    return promise
  }



  addFormControlsForPersonalDetails() { 
    this.personalDetailsFields.forEach(item => {
      this.personalDetailsDataEntryForm.addControl(item.name, new FormControl(''));
      if (item.mandatory) {
        this.personalDetailsDataEntryForm.get(item.name).setValidators(Validators.required);
      }
    })

  }
  getFieldSize(personalDetailsField) {
    return personalDetailsField.size;
  }

  saveConfirmation(){
    const confirmDialog = this.dialog.open(SaveConfirmationComponent,{
      width:'400px',data:{message:`Are you sure that you want to submit this form `}
    });
    confirmDialog.afterClosed().subscribe(result=>{
      if(result.event=='confirmed'){
        this.saveButtonClicked();
      }
    })  
  }



  saveButtonClicked() {
    let personalDetailsData = this.personalDetailsDataEntryForm.getRawValue()
    personalDetailsData.status = "CDE-COMPLETED"
    personalDetailsData.case = this.case_id
    if (this.personalDetails == null) {
      this.personalDetailsDataService.createForCde(personalDetailsData, this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          this.personalDetails = response._id
          this.navItems.forEach((item,index) => {
            if (item.displayName === 'Personal Details') {
                if (index < this.navItems.length - 1) {
                  this.navItems[index + 1].disable = false;
              } 
            }
          })
          this.showMessage("Personal Details Saved");
        },
        error => {
          this.showError(error.error.message);
        })
    } else {
      console.log('else personal details === ', this.personalDetails);
      this.personalDetailsDataService.updateForCde(this.personalDetails, personalDetailsData, this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          this.personalDetails = response._id
          this.navItems.forEach((item,index) => {
            if (item.displayName === 'Personal Details') {
                if (index < this.navItems.length - 1) {
                  this.navItems[index + 1].disable = false;
              } 
            }
          })
          this.showMessage("Personal Details Saved");
        },
        error => {
          this.showError("Error Updating Personal Details");
        })
    }

  }
  showError(msg) {
    this.snackBar.open(msg, 'Error', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' });
  }
  showMessage(msg) {
    this.snackBar.open(msg, 'Info', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' });
  }

}
